document.addEventListener('DOMContentLoaded', function() {
  const $blocks = jQuery('.block-person-items');
  if( $blocks.length === 0 ) return;

  const $scrollto = jQuery('.person-scrollto');
  if( $scrollto.length != 0 ) {

      // Stap 1-3: Vind alle H3's en voeg links toe aan $scrollto
      $blocks.each(function() {
        jQuery(this).find('h3[id]').each(function() {
          const $h3 = jQuery(this);
          const title = $h3.text();
          const id = $h3.attr('id');

          // Maak link element
          const $link = jQuery('<a>')
            .text(title)
            .attr('href', '#'+id)
            .attr('data-target-id', id)
            .addClass('scrollto-link'); // optioneel voor styling

          // Voeg link toe aan $scrollto
          $scrollto.append($link);
        });
      });

      // Stap 4: Scroll click event
      $scrollto.on('click', 'a.scrollto-link', function(e) {
        e.preventDefault();
        const targetId = jQuery(this).data('target-id');
        const $target = jQuery('#' + targetId);

        if( $target.length ) {
          const offsetTop = $target.offset().top;
          const offsetBase = 100;

          jQuery('html, body').animate({
            scrollTop: offsetTop - offsetBase
          }, 600); // 600ms smooth scroll
        }
      });

  }

  const $persons = jQuery('.article-person');
  const $personfilter = jQuery('.person-search input[type=search]');

  if( $personfilter.length != 0 ) {

    let debounceTimer = null;
    let isSyncing = false;

    function filterPersons(searchTerm) {
      searchTerm = searchTerm.toLowerCase();

      $persons.each(function() {
        const $person = jQuery(this);
        const text = $person.text().toLowerCase();

        if( text.includes(searchTerm) || searchTerm === '' ) {
          $person.show();
        } else {
          $person.hide();
        }
      });
    }

    $personfilter.on('input', function() {
      if( isSyncing ) return;

      const searchTerm = jQuery(this).val();

      // Sync alle velden zonder events te retriggeren
      isSyncing = true;
      $personfilter.not(this).val(searchTerm);
      isSyncing = false;

      // Debounce filtering
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        filterPersons(searchTerm);
      }, 300);
    });
  }

});
